<template>
    <views class="article">
        <loading
            v-if="loadingTab"
            color="#1989fa">
        </loading>
        <views
            v-else>
            <nav-bar
                :title="this.collected ? '我的收藏' : moduleTitle"
                :left-arrow="!!collected"
                @click-left="onClickLeft">
            </nav-bar>
            <search-bar
                v-if="banners.length > 0"
                :path="path"
                :querys="querys">
            </search-bar>
            <!-- <tab
                v-if="tabs.length > 0"
                :tabs="tabs"
                :active-name="moduleTitle"
                class="mb"
                @change="handleChange">
            </tab> -->
            <van-tabs color="#1989fa" @click="handleChange" v-model="activeName">
                <van-tab v-for="item in tabs" :title="item.name" :name="item.id" :key="item.id">
                    <!-- 内容 {{ index }} -->
                    <van-tabs v-if="secondTabs.length" class="vant-tab-my" style="margin: 14px 0;" @click="handleChirendChange" v-model="activeChirendName">
                        <van-tab v-for="item in secondTabs" :title="item.name" :name="item.id" :key="item.id">
                            
                        </van-tab>
                    </van-tabs>
                </van-tab>
            </van-tabs>
            <banner
                v-if="!this.collected && banners.length > 0"
                :list="banners">
            </banner>
            <article-list
                ref="articleList"
                v-if="tabs.length > 0"
                :collected="collected"
                :immediate="immediate"
                :keyword="keyword"
                :category="activeTab">
            </article-list>
        </views>
    </views>
</template>

<script>
import NavBar from '@/components/navBar'
import Loading from '@/components/loading'
import SearchBar from '@/components/searchBar'
import Banner from '@/components/banner'
import Tab from '@/components/tab'
import ArticleList from './ArticleList'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    name: 'Article',
    mixins: [tools],
    components: {
        NavBar,
        SearchBar,
        Tab,
        ArticleList,
        Loading,
        Banner
    },
    data() {
        return {
            isRefresh: false,
            tabs: [],
            secondTabs:[],
            banners: [],
            lists: [],
            activeTab: {},
            keyword: '',
            loadingTab: false,
            activeName:this.$route.query.categoryId,
            activeChirendName:'',
            immediate:false,//初始化列表时是否加载
        }
    },
    computed: {
        moduleTitle() {
            return this.activeTab.name
        },
        path() {
            return `to=${this.collected ? 'collected' : 'article'}&categoryId=${this.activeTab.id}&categoryName=${this.activeTab.name}`
        },
        querys() {
            return this.$route.query || {}
        },
        collected() {
            return location.pathname === '/collected'
        }
    },
    watch: {
        'querys.keyword': {
            handler(val) {
                this.keyword = val || ''
                if (this.querys.categoryId && this.querys.categoryName) {
                    this.immediate = true;
                    this.activeTab = {
                        id: this.querys.categoryId,
                        name: this.querys.categoryName
                    }
                }
                this.getCategory()
            },
            immediate: true
        }
    },
    methods: {
        onRefresh() {
            setTimeout(() => {
                this.isRefresh = false
            }, 1000)
        },
        onClickLeft() {
            if (this.$route.query.src === 'person') {
                this.back()
            } else {
                this.push('/person')
            }
        },
        handleChirendChange(val){
            if(!(this.querys.categoryId && this.querys.categoryName)){
                this.immediate = true;
            }
            this.secondTabs.map(item=>{
                if(val==item.id){
                    this.activeTab = item;
                }
            })
        },
        handleChange(val) {
            this.tabs.map(item=>{
                if(val==item.id){
                    this.activeTab = item;
                }
            })
            // this.activeTab = val
            this.keyword = this.querys.keyword
            this.getSecondCategory(this.activeTab)
        },
        handleSearch(val) {
            this.$refs.articleList.reload(val)
        },
        getSecondCategory(active){
            console.log(active,11);
            
            this.loadingTab = true
            api.getCategory({category_id:active.id}).then((res) => {
                if (res.data.list.length) {
                    this.secondTabs = res.data.list
                    this.activeTab = this.secondTabs.length > 0 && this.secondTabs[0]
                    this.handleChirendChange()
                }else{
                    this.secondTabs = res.data.list
                    if (!(this.querys.categoryId && this.querys.categoryName)) {
                        this.activeTab = active
                    }
                }
                this.loadingTab = false
            }).catch(() => {
                this.loadingTab = false
            })
        },
        getCategory() {
            this.loadingTab = true
            api.getCategory().then((res) => {
                if (res.data.list) {
                    this.tabs = res.data.list
                    if (!(this.querys.categoryId && this.querys.categoryName)) {
                        this.activeTab = this.tabs.length > 0 && this.tabs[0]
                        this.handleChange()
                    }
                    this.getBanner()
                }
                this.loadingTab = false
            }).catch(() => {
                this.loadingTab = false
            })
        },
        getBanner() {
            api.getCategoryBanner({ category_id: this.activeTab.id }).then((res) => {
                if (res.data.list) {
                    this.banners = res.data.list.map(item => ({
                        ...item,
                        url: item.banner_url
                    }))
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
::v-deep.van-tab--active {
    color: #fff !important;
}
::v-deep.vant-tab-my .van-tabs__wrap .van-tab {
    background: #eee;
    margin: 0 5px;
    border-radius: 50px;
}
::v-deep.vant-tab-my .van-tabs__wrap .van-tab--active{
    background: #1989fa;
    color: #fff;
}
::v-deep.vant-tab-my .van-tabs__wrap .van-tabs__line{
    background: transparent;
}
</style>
